import PropTypes from "prop-types";

import { Button, RadioButton } from "@transfr-inc/dashboard-components/forms";

import { Card, CardBody, CardHeader, ListItem, Modal } from "@features/ui";
import { buttonTracking } from "@lib/tracking.helpers";

import "./classroom-selection.modal.scss";

const trackingId = "career-details-classroom-selection-modal";

export const ClassroomSelectionModal = ({
  open,
  classrooms,
  selected,
  onSelect,
  onClose,
}) => {
  const toolbar = (
    <Button
      icon={["fa-regular", "xmark"]}
      onClick={onClose}
      {...buttonTracking(trackingId, "close")}
    />
  );

  return (
    <Modal
      key="classroom-selection-modal"
      modalClassName="classroom-selection-modal"
      open={open}
    >
      <Card>
        <CardHeader
          icon={["fa-solid", "xmark"]}
          title={<h1>Which classroom are you in?</h1>}
          toolbar={toolbar}
        />
        <CardBody>
          <p className="classroom-selection-info">
            Your sim pass will be sent to this classroom, so your teacher can
            see you.
          </p>
          <div
            className="classroom-selection-list"
            role="radiogroup"
            aria-label="Which classroom are you in?"
          >
            {classrooms.map(({ classroomId, name, code }) => (
              <ListItem
                key={classroomId}
                icon={false}
                className="classroom-selection-list-item"
              >
                <RadioButton
                  className="classroom-radio-content"
                  name="classroom-selection"
                  value={classroomId}
                  checked={classroomId === selected}
                  onChange={() => onSelect(classroomId)}
                >
                  <span className="classroom-name">{name}</span>
                  {code && <span className="classroom-code">{code}</span>}
                </RadioButton>
              </ListItem>
            ))}
          </div>
        </CardBody>
      </Card>
    </Modal>
  );
};

ClassroomSelectionModal.displayName = "Classroom Selection Modal";

ClassroomSelectionModal.propTypes = {
  open: PropTypes.bool,
  selected: PropTypes.string,
  classrooms: PropTypes.arrayOf(
    PropTypes.shape({
      classroomId: PropTypes.string.isRequired,
      name: PropTypes.string,
      code: PropTypes.string,
    }),
  ),
  onSelect: PropTypes.func,
  onClose: PropTypes.func,
};
